import * as React from 'react';
import {
  useNavigateLegacy as useNavigate,
  LinkLegacy as Link,
} from '@leagueplatform/routing';
import {
  Box,
  Flex,
  genesisStyled,
  HeadingOne,
} from '@leagueplatform/genesis-commons';
import {
  BackButtonArrow,
  PageHeaderBackground,
} from '@leagueplatform/web-common-components';

export type HealthProfilePageWrapperProps = {
  children: React.ReactNode;
  sidebar?: React.ReactNode;
  title: string;
  hideBackButton?: boolean;
  backButtonRoute?: string;
};

const PageContainer = genesisStyled(Flex)`
  max-width: 1272px;
`;

export function HealthProfilePageWrapper({
  children,
  sidebar,
  title,
  hideBackButton = false,
  backButtonRoute,
}: HealthProfilePageWrapperProps) {
  const navigate = useNavigate();
  const backButtonDestination = backButtonRoute || '#';
  return (
    <PageContainer
      flexWrap={{ laptop: 'noWrap', tablet: 'wrap', phone: 'wrap' }}
      margin="0 auto"
      paddingX="one"
    >
      <Flex
        marginInlineStart={{ _: 'none', laptop: 'two' }}
        marginInlineEnd={{ _: 'none', laptop: 'two' }}
        flexGrow={1}
        flexDirection={{ _: 'column' }}
        width="100%"
      >
        <PageHeaderBackground>
          <Flex alignItems="center" paddingBottom="one" position="relative">
            {!hideBackButton && (
              <BackButtonArrow
                as={Link}
                to={backButtonDestination}
                fontSize="heading1"
                marginInlineEnd="one"
                marginY="threeQuarters"
                justifyContent="initial"
                onClick={(event: React.MouseEvent) => {
                  if (backButtonRoute) {
                    return;
                  }
                  event.preventDefault();
                  navigate(-1);
                }}
                position="absolute"
                insetInlineStart={{ _: '0px', laptop: '-35px' }}
                top={{ _: '0px', laptop: 'unset' }}
              />
            )}
            <HeadingOne marginTop={{ _: 'oneAndHalf', laptop: 'none' }}>
              {title}
            </HeadingOne>
          </Flex>
        </PageHeaderBackground>
        <Flex justifyContent="space-between">
          <Box
            flexGrow={1}
            flexShrink={1}
            width="100%"
            maxWidth={sidebar ? '890px' : null}
            marginBottom={{ _: '180px', phone: '110px' }}
            className="health-profile-page-children-wrapper"
          >
            {children}
          </Box>
        </Flex>
      </Flex>
      {sidebar && (
        <Box
          padding="none"
          height="100%"
          width={{ laptop: 'initial', tablet: '100%', phone: '100%' }}
          marginTop="one"
        >
          {sidebar}
        </Box>
      )}
    </PageContainer>
  );
}
